import { render, staticRenderFns } from "./AlertSendForm.vue?vue&type=template&id=3e750572&scoped=true"
import script from "./AlertSendForm.vue?vue&type=script&lang=js"
export * from "./AlertSendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e750572",
  null
  
)

export default component.exports